import { atom } from "recoil";
import { IOfficeHierarchyDetails, SelectedRowsToDelete } from "../types";

export const officeHierarchyAddState = atom({
  key: "officeHierarchyAddState",
  default: false,
});
export const officeHierarchyEditState = atom({
  key: "officeHierarchyEditState",
  default: false,
});

export const setOfficeHierarchyRowForEdit = atom<
  IOfficeHierarchyDetails | undefined
>({
  key: "rowForEditSecurity",
  default: undefined,
});

export const officeHierarchyShowState = atom({
  key: "officeHierarchyShowState",
  default: false,
});

export const selectedRowsOfficeHierarchy = atom({
  key: "selectedRowsOfficeHierarchy",
  default: [],
});

export const officeHierarchyAll = atom({
  key: "officeHierarchyAll",
  default: [],
});
export const getHierarchyType = atom({
  key: "getHierarchyType",
  default: null,
});
export const addHierarchyState = atom({
  key: "addHierarchyState",
  default: false,
});
export const empHierarchyState = atom({
  key: "empHierarchyState",
  default: false,
});

export const getEmployeesOptFromEmployees = atom({
  key: "getEmployeesOptFromEmployees",
  default: [],
});
export const stateSelectedState = atom({
  key: "stateSelectedOfficeHierarchy",
  default: null,
});
export const officeHierarchyFilteredDataState = atom({
  key: "officeHierarchyFilteredDataState",
  default: [],
});

export const descriptionChangeState = atom({
  key: "descriptionChangeState",
  default: "",
});

export const isFromLinkState = atom({
  key: "isFromLinkState",
  default: false,
});

export const codeIdState = atom({
  key: "codeIdState",
  default: null,
});

export const selectedRowsStateToDeleteOF = atom<
  SelectedRowsToDelete | undefined
>({
  key: "selectedRowsStateToDeleteOF",
  default: undefined,
});

export const hierarchyTypeState = atom({
  key: "hierarchyTypeState",
  default: "",
});

export const hierarchyFormState = atom({
  key: "hierarchyFormState",
  default: {
    Form: null,
  },
});

export const officeHViewData = atom({
  key: "officeHViewData",
  default: undefined,
});

export const officeHierarchyRecordTypeState = atom({
  key: "officeHierarchyRecordTypeState",
  default: "",
});

export const officeHierarchyRecordTypeModalState = atom({
  key: "officeHierarchyRecordTypeModalState",
  default: false,
});

export const officeHierarchyModalState = atom({
  key: "officeHierarchyModalState",
  default: false,
});

export const openModalForm = atom({
  key: "openModalForm",
  default: false,
});

export const viewOfficeHierarchyModalState = atom({
  key: "viewOfficeHierarchyModalState",
  default: false,
});

export const viewSetIdStates = atom({
  key: "viewSetIdStates",
  default: null,
});

export const viewSetShowModalState = atom({
  key: "viewSetShowModalState",
  default: false,
});

export const editModalState = atom({
  key: "editModalState",
  default: false,
});

export const deleteOfficeHierarchyState = atom({
  key: "deleteOfficeHierarchyState",
  default: false,
});

export const officeHierarchyTitle = atom({
  key: "officeHierarchyTitle",
  default: "",
});

export const officeHierarchyOnCloseState = atom({
  key: "officeHierarchyOnCloseState",
  default: false,
});

export const officeHierarchyOnShowState = atom({
  key: "officeHierarchyOnShowState",
  default: false,
});

export const isParentClickState = atom({
  key: "isParentClickState",
  default: false,
});

export const recordIdToShowInTS = atom({
  key: "recordToShowInTS",
  default: 0,
});

export const ohFromEmployee = atom({
  key: "ohFromEmployee",
  default: false,
});

export const ohViewData = atom<any>({
  key: "ohViewData",
  default: undefined,
});

export const dataId = atom({
  key: "dataId",
  default: undefined,
});

export const onClickNsaFullPage = atom({
  key: "onClickNsaFullPage",
  default: false,
});

export const onClickSalesFullPage = atom({
  key: "onClickSalesFullPage",
  default: false,
});

export const onClickSplcFullPage = atom({
  key: "onClickSplcFullPage",
  default: false,
});

export const showTable = atom({
  key: "showTable",
  default: false,
});

export const officeFromOHChart = atom({
  key: "officeFromOHChart",
  default: false,
});
